import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
// EndTest moved to parent; handlers only submit and signal parent now
import { processAudioUpload } from "../utils/audioProcessing";
import { processQuestionSubmission } from "../utils/questionProcessing";

export const useSpeakingSubmission = ({
  quest,
  questData,
  recordingState,
  questionsTime,
  commulative,
  setCommulative,
  MockTestAttemptID,
  ExamId,
  step,
  totalQuestions,
  setStep,
  setNetworkError,
  resetQuestionTimer,
  audioRef,
  setClicked,
  stopStopwatch,
  endTestAndTimeout
}) => {
  const navigate = useNavigate();

  const handleNext = useCallback(() => {
    if (recordingState.disabledButton) return;
    if (audioRef.current) audioRef.current.pause();

    setClicked((prev) => !prev);
    recordingState.setDisabledButton(true);
    stopStopwatch();
  }, [recordingState.disabledButton, audioRef, setClicked, recordingState.setDisabledButton, stopStopwatch]);

  const handleExit = useCallback(() => {
    if (audioRef.current) audioRef.current.pause();
    navigate("/MockTest");
  }, [audioRef, navigate]);

  const handleQuestionSubmission = useCallback(async () => {
    // Convert to number explicitly
    const timeSpent = Math.floor(questionsTime / 1000);
    
    // Ensure commulative is treated as a number
    const currentCumulative = parseInt(commulative, 10) || 0;
    
    console.log("[useSpeakingSubmission]: Time spent on question (seconds):", timeSpent);
    console.log("[useSpeakingSubmission]: Cumulative time before update (seconds):", currentCumulative);
    
    // Perform numeric addition
    const updatedCommulative = currentCumulative + timeSpent;
    
    console.log("[useSpeakingSubmission]: Cumulative time after update (seconds):", updatedCommulative);
    
    setCommulative(updatedCommulative);

    resetQuestionTimer();

    const audioUrl = await processAudioUpload(recordingState.recordedBlobFile);

    const res = await processQuestionSubmission({
      quest,
      questData,
      transcript: recordingState.transcript,
      timeSpent,
      commulative: updatedCommulative,
      MockTestAttemptID,
      ExamId,
      audioUrl
    });

    recordingState.setRecordedAudioFile(null);
    
    if (res.error) {
      setNetworkError(true);
      setTimeout(() => navigate("/MockTest"), 2000);
    } else {
      if (!quest?.IsAttempted) {
        quest.IsAttempted = true;
      }
    }

    if (!res.error && step === totalQuestions && typeof endTestAndTimeout === 'function') {
      endTestAndTimeout().then(() => {});
    }
    
  }, [
    quest,
    questData,
    recordingState.recordedBlobFile,
    recordingState.transcript,
    recordingState.setRecordedAudioFile,
    questionsTime,
    commulative,
    setCommulative,
    MockTestAttemptID,
    ExamId,
    step,
    totalQuestions,
    setNetworkError,
    navigate,
    resetQuestionTimer
  ]);

  return {
    handleNext,
    handleExit,
    handleQuestionSubmission
  };
};
